;
define("quick_order.tpl", function(){});

